// extracted by mini-css-extract-plugin
export default {"mainContainer":"displayMission_mainContainer__ODGNE","title":"displayMission_title__jk92y","container":"displayMission_container__hre0O","list":"displayMission_list__PWKSa"};